import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-565743fd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-banner"
};
const _hoisted_2 = {
  class: "loan-banner-content flex-row-space-between"
};
const _hoisted_3 = {
  class: "banner-left flex-col"
};
const _hoisted_4 = {
  "data-paint": ""
};
const _hoisted_5 = {
  class: "flex-row flex-items-center"
};
const _hoisted_6 = {
  class: "flex-row"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "flex-1"
};
const _hoisted_9 = {
  class: "flex-row"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "flex-1"
};
const _hoisted_12 = {
  class: "flex-row"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "flex-1"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('loan_pledge')), 1), _createElementVNode("p", null, _toDisplayString($setup.t('loan_pledge_desc')), 1), _createElementVNode("ul", _hoisted_5, [_createElementVNode("li", _hoisted_6, [_createElementVNode("img", {
    "data-paint": "",
    class: "icon",
    src: $setup.getRelativeUrl('https://fh-static.bycsi.com/banner-icon1-9b87d2b02df31136a2145ce0c5296b8f.svg')
  }, null, 8, _hoisted_7), _createElementVNode("span", _hoisted_8, _toDisplayString($setup.t('loan_high_exchange_rate')), 1)]), _createElementVNode("li", _hoisted_9, [_createElementVNode("img", {
    class: "icon",
    src: $setup.getRelativeUrl('https://fh-static.bycsi.com/banner-icon2-169b0f98420d046486647ad66de9aecd.svg')
  }, null, 8, _hoisted_10), _createElementVNode("span", _hoisted_11, _toDisplayString($setup.t('loan_repay_anytime')), 1)]), _createElementVNode("li", _hoisted_12, [_createElementVNode("img", {
    class: "icon",
    src: $setup.getRelativeUrl('https://fh-static.bycsi.com/banner-icon3-ba0c1286677272fd936f7831e64e0349.svg')
  }, null, 8, _hoisted_13), _createElementVNode("span", _hoisted_14, _toDisplayString($setup.t('loan_instant_credit')), 1)])])]), _createElementVNode("img", {
    src: $setup.getRelativeUrl('https://fh-static.bycsi.com/banner-d1075c1bc957e197647bcb3ddcb84a98.svg'),
    alt: "",
    class: "banner-right"
  }, null, 8, _hoisted_15)])]);
}